import Enum from './enum'

class OrderStatus extends Enum {
    static PENDING = 10; // 未処理
    static APPROVED = 20; // 確定済
    static WAITING = 25; // 発送待ち
    static SHIPPED  = 30; // 発送済
    static RECORDED = 40; // 売上計上済
    static CANCELED = 99; // キャンセル

    static values() {
        return {
            [this.PENDING]: '未処理',
            [this.APPROVED]: '確定済',
            [this.WAITING]: '発送待ち',
            [this.SHIPPED]: '発送済',
            [this.RECORDED]: '売上計上済',
            [this.CANCELED]: 'キャンセル',
        }
    }
    static valuesForDistributor() {
        return {
            [this.PENDING]: '保留中',
            [this.APPROVED]: '保留中',
            [this.WAITING]: '保留中',
            [this.SHIPPED]: '発送済',
            [this.RECORDED]: '発送済',
            [this.CANCELED]: 'キャンセル',
        }
    }

    static optionsForDistributor() {
        // ラベルを key として，ステータスを配列として value にもつ Object を作る
         const map = Object
            .entries(this.valuesForDistributor())
            .reduce((acc, cur) => {
                if (Array.isArray(acc[cur[1]])) {
                    acc[cur[1]].push(cur[0]);
                } else {
                    acc[cur[1]] = [cur[0]];
                }

                return acc;
            }, {});

         // 配列をカンマ区切りで結合して，form-select の形に合わせる
         return Object
             .keys(map)
             .map(s => {
                 return {
                     label: s,
                     key: map[s].join(','),
                 };
             });
    }

    static getForDistributor(key) {
        const values = this.valuesForDistributor();

        if (key in values) {
            return values[key];
        }

        return null;
    }

    static printable(status) {
        return [
            this.APPROVED,
            this.WAITING,
            this.SHIPPED,
            this.RECORDED,
        ].includes(status)
    }

    static cancelable(status) {
        return status === this.PENDING
    }

    static appropriatable(status) {
        return status === this.SHIPPED
    }
}

export default OrderStatus;
